export default [
    {
        url: "/campus/campus",
        name: "Campus",
        slug: "campus",
        permission: "vp.campus.show",
        icon: "FileTextIcon",
    },
];
